import { Component } from 'react';
import { Row, Col, Card, Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Layout from './DashboardLayout';
import { workSessionService } from '../services';
import Loading from '../components/Loader';
import { NoDataAlert } from '../components/common';
import AddNewBreak from '../components/breaks/AddNewBreak';
import EditBreak from '../components/breaks/EditBreak';

class BreakManagement extends Component {
  state = {
    isLoading: false,
    breaksList: [],
    showAddBreakModal: false,
    showEditBreakModal: false,
    selectedBreak: {},
  };

  pageHeading = {
    preTitle: 'Manage',
    title: `Breaks`,
  };

  componentDidMount() {
    this.handleGetBreaksList();
  }

  handleGetBreaksList = async () => {
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));
    workSessionService
      .get_breaks_list({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
      })
      .then((response) => {
        if (response.data) {
          this.setState((state) => ({
            ...state,
            breaksList: response.data,
          }));
        }
      })
      .finally(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  handleAddNewBreak = async (params) => {
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));

    const breakParams = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      name: params.breakName,
      shortCode: params.shortCode,
      billable: params.billable,
    };
    if (params.shortCode === '') {
      delete breakParams.shortCode;
    }
    workSessionService
      .create_new_break(breakParams)
      .then((response) => {
        if (response.status) {
          this.handleAddBreakModalDisplay(false);
          this.handleGetBreaksList();
        }
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  handleEditBreak = async (params) => {
    const breakParams = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      id: params.breakId,
      name: params.breakName,
      shortCode: params.shortCode,
      billable: params.billable,
    };
    if (params.shortCode === '') {
      delete breakParams.shortCode;
    }
    workSessionService.edit_break(breakParams).then((response) => {
      if (response.status) {
        toast.success('Break updated successfully');
        this.handleGetBreaksList();
        this.handleEditBreakModalDisplay(false);
      }
    });
  };

  handleAddBreakModalDisplay = (dState) => {
    this.setState((state) => ({
      ...state,
      showAddBreakModal: dState,
    }));
  };

  handleEditBreakModalDisplay = (dState) => {
    this.setState((state) => ({
      ...state,
      showEditBreakModal: dState,
    }));
  };

  handleSelectedBreak = (breakInfo) => {
    this.setState((state) => ({
      ...state,
      selectedBreak: breakInfo,
    }));
  };

  render() {
    const {
      isLoading,
      showAddBreakModal,
      showEditBreakModal,
      selectedBreak,
      breaksList,
    } = this.state;
    const { permissions } = this.props;
    return (
      <Layout pageHeading={this.pageHeading}>
        <Row className="justify-content-center">
          <Col className="col-12">
            <Card className="mb-5">
              <Card.Header>
                <h4 className="m-0">Breaks</h4>
                {permissions && permissions.includes('break_manage') && (
                  <AddNewBreak
                    showAddBreakModal={showAddBreakModal}
                    handleAddBreakModalDisplay={this.handleAddBreakModalDisplay}
                    handleAddNewBreak={this.handleAddNewBreak}
                  />
                )}
              </Card.Header>
              <Card.Body className="px-0 pb-0">
                <div className="table-responsive">
                  <table className="table table-sm table-hover card-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Short Code</th>
                        <th align="center" style={{ width: '50px' }}>
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {breaksList?.length > 0 &&
                        breaksList.map((breakItem) => (
                          <tr>
                            <td>{breakItem.name}</td>
                            <td>{breakItem.shortCode || '-'}</td>
                            <td align="center" style={{ width: '50px' }}>
                              <Dropdown
                                className="card-dropdown"
                                style={{
                                  position: 'relative',
                                  top: '0',
                                  right: '0',
                                }}
                                id="edit-dropdown"
                              >
                                <Dropdown.Toggle
                                  as={Link}
                                  to={{ hash: '#' }}
                                  className="dropdown-ellipses dropdown-toggle"
                                >
                                  <i className="mdi mdi-dots-horizontal" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="left">
                                  <Dropdown.Item
                                    onClick={() => {
                                      this.handleSelectedBreak({
                                        ...breakItem,
                                      });
                                      this.handleEditBreakModalDisplay(true);
                                    }}
                                  >
                                    Edit
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                {showEditBreakModal && (
                  <EditBreak
                    selectedBreak={selectedBreak}
                    showEditBreakModal={showEditBreakModal}
                    handleEditBreakModalDisplay={
                      this.handleEditBreakModalDisplay
                    }
                    handleEditBreak={this.handleEditBreak}
                  />
                )}
                {!isLoading && breaksList < 1 && (
                  <NoDataAlert content="No breaks are created yet." />
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {/* Loader */}
        {isLoading && <Loading contentAreaOnly />}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.permissionsReducer,
});

BreakManagement.propTypes = {
  permissions: PropTypes.array,
};

export default connect(mapStateToProps)(BreakManagement);
